export const loginRoutes = {
  path: '/login',
  name: 'login',
  meta: { onlyUnauthorized: true },
  component: () => import('./Login.vue'),
};
